import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbaa3a72"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mobility", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Access", -1))
const _hoisted_3 = { class: "grid grid-cols-2 gap-1" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-1" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-1" }
const _hoisted_6 = { class: "grid grid-cols-2 gap-1" }
const _hoisted_7 = { class: "grid grid-cols-2 gap-1" }
const _hoisted_8 = {
  key: 0,
  class: "grid grid-cols-1 gap-1"
}
const _hoisted_9 = { class: "grid grid-cols-2 gap-1" }

import { computed, ref } from 'vue';

import Button from '@/elements/button/Button.vue';
import Box from '@/elements/box/Box';
import { PrioritySet } from './typings';
import Scorebox from './Scorebox.vue';

type ScoreSet = {
  safety: number;
  'pedestrian:mobility': number;
  'pedestrian:access': number;
  greening: number;
  'bicycle:mobility': number;
  'bicycle:access': number;
  'transit:mobility': number;
  'transit:access': number;
  'freight:mobility': number;
  'freight:access': number;
  'traffic:mobility': number;
  'traffic:access': number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Scorecard',
  props: {
  scores: {
    type: Object as () => ScoreSet,
    required: true,
  },
  mainStreet: {
    type: Boolean,
    default: false,
  },
  priorities: {
    type: Object as () => PrioritySet,
    default: () => ({
      pedestrian: 'higher',
      bicycle: 'higher',
      transit: 'higher',
      freight: 'higher',
      traffic: 'higher',
    }),
  },
  showControls: {
    type: Boolean,
    default: true,
  },
},
  emits: ['move-left', 'move-right'],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const disabled = ref(false);

const classes = computed(() => {
  return {
    'transition-opacity': true,
    'opacity-25': disabled.value,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Box), {
      as: "header",
      class: _normalizeClass(["flex flex-col gap-1 transition-opacity", classes.value])
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default"),
        _createVNode(_unref(Box), {
          color: "gray",
          variant: "light",
          class: "p-2 rounded-md grid grid-cols-2 gap-1 justify-items-center"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["class"]),
    _createVNode(Scorebox, {
      score: __props.scores.safety,
      title: "Safety score",
      class: _normalizeClass(classes.value)
    }, null, 8, ["score", "class"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Scorebox, {
        score: __props.scores['pedestrian:mobility'],
        priority: __props.priorities.pedestrian,
        title: "Pedestrian mobility score",
        class: _normalizeClass(classes.value)
      }, null, 8, ["score", "priority", "class"]),
      _createVNode(Scorebox, {
        score: __props.scores['pedestrian:access'],
        priority: 
        !__props.mainStreet
          ? __props.priorities.pedestrian
          : __props.priorities.pedestrian == 'none'
          ? 'none'
          : 'higher'
      ,
        title: "Pedestrian access score",
        class: _normalizeClass(classes.value)
      }, null, 8, ["score", "priority", "class"])
    ]),
    _createVNode(Scorebox, {
      score: __props.scores.greening,
      title: "Greening score",
      class: _normalizeClass(classes.value)
    }, null, 8, ["score", "class"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Scorebox, {
        score: __props.scores['bicycle:mobility'],
        priority: __props.priorities.bicycle,
        title: "Bicycle mobility score",
        class: _normalizeClass(classes.value)
      }, null, 8, ["score", "priority", "class"]),
      _createVNode(Scorebox, {
        score: __props.scores['bicycle:access'],
        priority: 
        !__props.mainStreet
          ? __props.priorities.bicycle
          : __props.priorities.bicycle == 'none'
          ? 'none'
          : 'higher'
      ,
        title: "Bicycle access score",
        class: _normalizeClass(classes.value)
      }, null, 8, ["score", "priority", "class"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(Scorebox, {
        score: __props.scores['transit:mobility'],
        priority: __props.priorities.transit,
        title: "Transit mobility score",
        class: _normalizeClass(classes.value)
      }, null, 8, ["score", "priority", "class"]),
      _createVNode(Scorebox, {
        score: __props.scores['transit:access'],
        priority: 
        !__props.mainStreet
          ? __props.priorities.transit
          : __props.priorities.transit == 'none'
          ? 'none'
          : 'higher'
      ,
        title: "Transit access score",
        class: _normalizeClass(classes.value)
      }, null, 8, ["score", "priority", "class"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Scorebox, {
        score: __props.scores['freight:mobility'],
        priority: __props.priorities.freight,
        title: "Freight mobility score",
        class: _normalizeClass(classes.value)
      }, null, 8, ["score", "priority", "class"]),
      _createVNode(Scorebox, {
        score: __props.scores['freight:access'],
        priority: 
        !__props.mainStreet
          ? __props.priorities.freight
          : __props.priorities.freight == 'none'
          ? 'none'
          : 'higher'
      ,
        title: "Freight access score",
        class: _normalizeClass(classes.value)
      }, null, 8, ["score", "priority", "class"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(Scorebox, {
        score: __props.scores['traffic:mobility'],
        priority: __props.priorities.traffic,
        title: "Traffic mobility score",
        class: _normalizeClass(classes.value)
      }, null, 8, ["score", "priority", "class"]),
      _createVNode(Scorebox, {
        score: __props.scores['traffic:access'],
        priority: 
        !__props.mainStreet
          ? __props.priorities.traffic
          : __props.priorities.traffic == 'none'
          ? 'none'
          : 'higher'
      ,
        title: "Traffic access score",
        class: _normalizeClass(classes.value)
      }, null, 8, ["score", "priority", "class"])
    ]),
    (__props.showControls)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(Button, {
            size: "small",
            label: disabled.value ? 'Show' : 'Hide',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (disabled.value = !disabled.value))
          }, null, 8, ["label"]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Button, {
              size: "small",
              label: "Move left",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('move-left')))
            }),
            _createVNode(Button, {
              size: "small",
              label: "Move right",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('move-right')))
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})